import React from 'react';
import styled, { keyframes } from '../styled-components';
var scaleAnimation =
/*#__PURE__*/
keyframes(["0%,70%,100%{transform:scale3D(1,1,1);}35%{transform:scale3D(0,0,1);}"]);
var SpinnerContainer =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Spinner__SpinnerContainer",
  componentId: "l9s2l2-0"
})(["width:40px;height:40px;"]);
var Cube =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Spinner__Cube",
  componentId: "l9s2l2-1"
})(["width:33%;height:33%;background-color:", ";float:left;animation:", " 1.3s infinite ease-in-out;"], function (props) {
  return props.theme.color.primary.lightBlue;
}, scaleAnimation);
var Cube1 =
/*#__PURE__*/
styled(Cube).withConfig({
  displayName: "Spinner__Cube1",
  componentId: "l9s2l2-2"
})(["animation-delay:0.2s;"]);
var Cube2 =
/*#__PURE__*/
styled(Cube).withConfig({
  displayName: "Spinner__Cube2",
  componentId: "l9s2l2-3"
})(["animation-delay:0.3s;"]);
var Cube3 =
/*#__PURE__*/
styled(Cube).withConfig({
  displayName: "Spinner__Cube3",
  componentId: "l9s2l2-4"
})(["animation-delay:0.4s;"]);
var Cube4 =
/*#__PURE__*/
styled(Cube).withConfig({
  displayName: "Spinner__Cube4",
  componentId: "l9s2l2-5"
})(["animation-delay:0.1s;"]);
var Cube5 =
/*#__PURE__*/
styled(Cube).withConfig({
  displayName: "Spinner__Cube5",
  componentId: "l9s2l2-6"
})(["animation-delay:0.2s;"]);
var Cube6 =
/*#__PURE__*/
styled(Cube).withConfig({
  displayName: "Spinner__Cube6",
  componentId: "l9s2l2-7"
})(["animation-delay:0.3s;"]);
var Cube7 =
/*#__PURE__*/
styled(Cube).withConfig({
  displayName: "Spinner__Cube7",
  componentId: "l9s2l2-8"
})(["animation-delay:0s;"]);
var Cube8 =
/*#__PURE__*/
styled(Cube).withConfig({
  displayName: "Spinner__Cube8",
  componentId: "l9s2l2-9"
})(["animation-delay:0.1s;"]);
var Cube9 =
/*#__PURE__*/
styled(Cube).withConfig({
  displayName: "Spinner__Cube9",
  componentId: "l9s2l2-10"
})(["animation-delay:0.2s;"]);
export default function Spinner(props) {
  return React.createElement(SpinnerContainer, {
    className: props.className
  }, React.createElement(Cube1, null), React.createElement(Cube2, null), React.createElement(Cube3, null), React.createElement(Cube4, null), React.createElement(Cube5, null), React.createElement(Cube6, null), React.createElement(Cube7, null), React.createElement(Cube8, null), React.createElement(Cube9, null));
}